import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '~/components/core/Atomic/Tooltip';

import { isProductionEnv } from '../../../../Utils';

const FsTooltip = ({ children, title, placement, arrow, disabled }) => {
  if (Array.isArray(children) || !React.isValidElement(children)) {
    if (!isProductionEnv()) {
      // eslint-disable-next-line no-console
      console.warn('FsTooltip: tooltip children should be a single node');
    }
    return children;
  }
  // Never pass `open`. MUI's Tooltip freezes the controlled-vs-uncontrolled decision on its first render
  // (useControlled memoizes `controlled !== undefined`), so an `open` that flips later is inert both ways:
  // mount with an empty title and a title arriving later can never open it, mount with a title and a
  // `disabled` set later can never close it. Neither half of that prop was needed — MUI already refuses to
  // open on an empty title, and Atomic's Tooltip already renders the children bare when `disabled`.
  // `|| ''` rather than `?? ''` because MUI's guard tests `title === ''`: a caller writing
  // `title={cond && 'text'}` passes `false`, which would otherwise open an empty bubble.
  return (
    <Tooltip disabled={disabled} title={title || ''} placement={placement} arrow={arrow}>
      <span>{children}</span>
    </Tooltip>
  );
};

// TODO update placement option after merging the FsButton PR NGTPA-6010
FsTooltip.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  placement: PropTypes.string,
  arrow: PropTypes.bool,
  disabled: PropTypes.bool,
};

FsTooltip.defaultProps = {
  placement: 'top',
};

export default FsTooltip;
